import './MesJuntsLabel.scss';

function MesJuntsLabel() {
  return (
    <div className="mesjuntslabel__container">
      <h2>
        <span>MÉS</span>
        JUNTS
      </h2>
    </div>
  );
}

export default MesJuntsLabel;
